import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	issuesWithoutParent: {
		id: 'portfolio-3-portfolio.app-simple-plans.main.tabs.dependencies.other-issues.issues-without-parent',
		defaultMessage: '{count} {count, plural, one {issue} other {issues}} without parent',
		description: 'Heading for issues without parent node',
	},
	issuesWithoutTeam: {
		id: 'portfolio-3-portfolio.app-simple-plans.main.tabs.dependencies.other-issues.issues-without-team',
		defaultMessage: '{count} {count, plural, one {issue} other {issues}} without team',
		description: 'Heading for issues without team node',
	},
});
